<template>
  <div class="home">
    <PageHeader :headers="pageData.headers" />
    <div v-for="(section, index) in pageData.sections" :key="index">
        <AboutSection 
            v-if="section.type === 'about'" 
            :heading="section.heading" 
            :content="section.content" 
            :showHeading="section.showHeading"
        />
        <ContentSection 
            v-else-if="section.type === 'content'" 
            :heading="section.heading" 
            :content="section.content" 
            :showHeading="section.showHeading"
            :sectionStyle="section.style"
        />
        <RecentVideosSection v-else-if="section.type === 'recent_videos'" :count="section.config?.count || 3"/>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import ContentSection from '@/components/ContentSection.vue';
import AboutSection from '@/components/AboutSection.vue';
import RecentVideosSection from '@/components/RecentVideosSection.vue';
import VideoService from '@/services/VideoService';
import PageService, { HeaderData, SectionData, PageData } from '@/services/PageService';

export default defineComponent({
  name: 'HomeView',
  components: {
    PageHeader,
    ContentSection,
    AboutSection,
    RecentVideosSection
  },
  data() {
      const latestVideo = VideoService.getLatestVideo();
      const pageData = PageService.getPage('home');
      pageData.headers.push({
          heading: 'Latest Video',
          title: latestVideo.title,
          content: `<p>${latestVideo.description}</p>`,
          backgroundImage: latestVideo.thumbnail,
          video: {
              url: latestVideo.url,
              thumbnail: latestVideo.thumbnail,
              slug: latestVideo.slug
          }
      });
      return {
          pageData: pageData
      }
  }
});
</script>
